<template>
  <div id="app">

    <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css">

    
    <!-- b-container ajouter un espace gauche et droite autour du component. Mais pour le login on a besoin d'un component fullscreen -->
    <!-- <div v-if="isLoggedIn" fluid class="cont_css"> 
      <Home></Home>
    </div>
    <Home v-else></Home> -->
    <Home></Home>
  </div>
</template>

<script>
import SocketioService from '@/plugins/socket/socketio.service.js'
import {mapGetters} from 'vuex'
import Home from './views/Home'
import store from '@/store';
import {userService} from '@/services'

export default {
  name: 'App',
  components: {
    Home
  },
  data() {
        return{
            socketId : '',
            clientId : '',
            socketData : {}
        }
    },
  methods: {
    joinServer() {
        //console.log(">>>>>>>>>> envoi subscription");
        SocketioService.getSocket().emit('subscribe', (response) => {
            //console.log(">>>>>>>>>> client subscription");
            this.socketId = response.socketId
            this.clientId = response.clientId
        });
        this.listen();
    },
    listen() {
        SocketioService.getSocket().on('myBroadcast', (data) => {
            this.socketData = JSON.stringify(data)
            store.dispatch(data.action, this.socketData)
        });
    },
    //setScreenSize() {
    //    this.$store.commit('changeScreenSizeW', window.innerWidth)
    //    this.$store.commit('changeScreenSizeH', window.innerHeight)
    //},
  },
  created() {
    SocketioService.setupSocketConnection();
  },
  beforeUnmount() {
    SocketioService.disconnectSocket()
  },
  updated() {
      //this.setScreenSize()
  },
  computed: {
    ...mapGetters(['allSize']),
    isLoggedIn : () => userService.isLoggedIn()
  },
  mounted() {
    this.joinServer();
    //this.setScreenSize()
  },
}
</script>

<style lang="scss">
@import './assets/styles/custom.scss'; //pour changer les couleur du theme principale
@import '../node_modules/bootstrap/scss/bootstrap.scss';

//TEST NAV BAR PERSONNALISÉ
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@400&display=swap");
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
}

.cont_css{
  background-color: $cBackLeftDark;
}

//* {
//  padding: 0;
//  margin: 0;
//  box-sizing: border-box;
//  font-family: "Raleway", sans-serif;
//  font-weight: 400;
//  font-size: 14px;
//}

//POLICE DE CARACTERE
@font-face {
  font-family: "Montserrat";
  src: local("Montserrat-Regular.ttf"),
   url(./fonts/montserrat/Montserrat-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Montserrat-Medium";
  src: local("Montserrat-Medium.ttf"),
   url(./fonts/montserrat/Montserrat-Medium.ttf) format("truetype");
}

//@font-face {
//  font-family: "Montserrat";
//  src: local("Montserrat-Bold.ttf"),
//   url(./fonts/montserrat/Montserrat-Bold.ttf) format("truetype");
//}

</style>
